module.exports = __webpack_public_path__ + "img/5.2237328f.png";